import {
    takeLatest, all, put, call, select,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/EventManagement';
import { waitAuthorizedCheck } from './Auth';

function* getListEvent(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: '/api/v1/event/',
                body: {
                    ...action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.GetListEventReceived(response));
    } catch (error) {
        yield put(Actions.GetListEventReceiveFailure(yield error));
    }
}

function* getDetailEvent(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailEventReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailEventReceivedFailure(yield error));
    }
}

function* createEvent(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.postWithFile,
            {
                endpoint: '/api/v1/event/',
                body: action.payload,
                token: credential.data.token,
            },
        );
        yield put(Actions.CreateEventReceived(response));
    } catch (error) {
        yield put(Actions.CreateEventReceivedFailure(yield error));
    }
}

function* createRoleEvent(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.postWithFile,
            {
                endpoint: '/api/v1/event/validate_sub_admins_info/',
                body: action.payload,
                token: credential.data.token,
            },
        );
        yield put(Actions.CreateRoleEventReceived(response));
    } catch (error) {
        yield put(Actions.CreateRoleEventFailure(yield error));
    }
}

function* editEvent(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.putWithFile,
            {
                endpoint: `/api/v1/event/${action.payload.id}/`,
                body: action.payload,
                token: credential.data.token,
            },
        );
        yield put(Actions.EditEventReceived(response));
    } catch (error) {
        yield put(Actions.EditEventReceivedFailure(yield error));
    }
}

function* deleteEvent(action) {

    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.delete,
            {
                endpoint: `/api/v1/event/${action.payload}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.DeleteEventReceived(response));
    } catch (error) {
        yield put(Actions.DeletEventReceivedFailure(yield error));
    }
}

function* getListCompanyEvent(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const resultsState = yield select((state) => state.eventManagement.listCompanyEvents.data.results);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/company/`,
                body: {
                    ...(action.payload.page && { page: action.payload.page }),
                },
                token: credential.data.token,
            },
        );
        let dataResult = [];
        if (resultsState && !action.payload.isPageFooter) {
            dataResult = { ...response, results: [...resultsState, ...response.results] };
        } else {
            dataResult = response;
        }
        yield put(Actions.GetListCompanyEventReceived(dataResult));
    } catch (error) {
        yield put(Actions.GetListCompanyEventReceivedFailure(yield error));
    }
}

function* getInfoEvent(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/event/${action.payload?.shortName}/info/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload}/info/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {},
            },
        );
        yield put(Actions.GetInfoEventReceived(response));
    } catch (error) {
        yield put(Actions.GetInfoEventReceivedFailure(yield error));
    }
}

export default function* EventManagement() {
    yield all([
        takeLatest('GET_LIST_EVENT_REQUESTED', getListEvent),
        takeLatest('GET_DETAIL_EVENT_REQUESTED', getDetailEvent),
        takeLatest('CREATE_EVENT_REQUESTED', createEvent),
        takeLatest('EDIT_EVENT_REQUESTED', editEvent),
        takeLatest('DELETE_EVENT_REQUESTED', deleteEvent),
        takeLatest('GET_LIST_COMPANY_EVENT_REQUESTED', getListCompanyEvent),
        takeLatest('GET_INFO_EVENT_REQUESTED', getInfoEvent),
        takeLatest('CREATE_ROLE_EVENT_REQUEST', createRoleEvent),
    ]);
}
